import cn from './cn.json';
import en from './en.json';
import jp from './jp.json';
import tw from './tw.json';

export const hiroLocale = { cn, en, jp, tw };

export function getHiroLocale(lang: 'cn' | 'en' | 'jp' | 'tw') {
    return hiroLocale[lang] || hiroLocale.en;
}
